/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Imagessetascover3Inputs */

const en_imagessetascover3 = /** @type {(inputs: Imagessetascover3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set as cover`)
};

const de_imagessetascover3 = /** @type {(inputs: Imagessetascover3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Als Titelbild`)
};

/**
* | output |
* | --- |
* | "Set as cover" |
*
* @param {Imagessetascover3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const imagessetascover3 = /** @type {((inputs?: Imagessetascover3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Imagessetascover3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_imagessetascover3(inputs)
	return de_imagessetascover3(inputs)
});
export { imagessetascover3 as "imagesSetAsCover" }